import { lightThemeIconMap } from '../light';
import { IconMap } from '../types';

/**
 * Foot Locker icon map
 *
 * Inherits all icons from the light theme map by default.
 * Override entries here when Foot Locker needs:
 *   - A different SVG (swap `default` / `filled`)
 *   - A different color token (swap `defaultColor` / `filledColor`)
 *
 * Color tokens resolve against footlockerTheme, so most icons
 * already render correctly without overrides — only add entries
 * that genuinely differ.
 *
 * @example — different SVG
 * [IconName.HOME]: {
 *   default: loadable(() => import('./adapters/FootlockerLogoAdapter')),
 *   defaultColor: 'textPrimary',
 * },
 *
 * @example — same SVG, different color token
 * [IconName.WISHLIST]: {
 *   ...lightThemeIconMap[IconName.WISHLIST],
 *   filledColor: 'primary',
 * },
 */
export const footlockerIconMap: IconMap = {
    ...lightThemeIconMap,
    // Add Foot Locker-specific overrides below
};
